import { ArrowRightStartOnRectangleIcon, BanknotesIcon, Cog6ToothIcon, KeyIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import { isSVGString } from ".";

export const getNavigateLink = (resData) => {
  if (!resData?.is_content) return `/workspace/${resData.workspace}/no-content`;

  const base = `/workspace/${resData.workspace}/embed`;

  if (!resData.content_type) return base;

  const queryParams = [];

  if (resData.group) queryParams.push(`group=${resData.group}`);

  queryParams.push(`${resData.content_type}=${resData.content_value}`);

  return `${base}?${queryParams.join("&")}`;
};

export const getUserMenuData = ({ user, workspaceDetails, overflowedHeaderMenus, setIsOpenModal, logout, UserImage, switchAdminButtonDisabled, onHandleSwitchToAdmin, navigateToPaymemnts, navigateToSettings }) => {
  const shouldShowUserBlock = workspaceDetails?.notification_banner_enable || window.innerWidth < 1280;

  const userBlock = shouldShowUserBlock
    ? [
        {
          _id: `user-${user?._id || "guest"}`,
          image: user?.image || UserImage,
          label: `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "User",
          standout: false,
          type: "user",
        },
        { _id: "divider-user", type: "divider" },
      ]
    : [];

  const divider = overflowedHeaderMenus?.length
    ? [
        {
          _id: "label-header-menus",
          label: "HEADER MENUS",
          standout: false,
          type: "label",
        },
      ]
    : [];

  const overflowItems =
    overflowedHeaderMenus?.map((item, idx) => {
      if (item.isGroup && item.submenu?.length > 0) {
        return {
          _id: `overflow-group-${item._id || idx}`,
          label: item.name,
          image: item.image,
          icon: isSVGString(item.image)
            ? () => (
                <span
                  className="h-4 w-4"
                  dangerouslySetInnerHTML={{
                    __html: item.image?.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"').replace(/stroke="[^"]*"/g, 'stroke="currentColor"'),
                  }}
                />
              )
            : null,
          standout: false,
          type: "group",
          submenu: item.submenu.map((subItem, subIdx) => ({
            _id: `overflow-${item._id}-${subItem._id || subIdx}`,
            slug: subItem.slug || subItem._id,
            label: subItem.name,
            image: subItem.image,
            icon: isSVGString(subItem.image)
              ? () => (
                  <span
                    className="h-4 w-4"
                    dangerouslySetInnerHTML={{
                      __html: subItem.image?.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"').replace(/stroke="[^"]*"/g, 'stroke="currentColor"'),
                    }}
                  />
                )
              : null,
            standout: false,
            link: subItem.link,
          })),
        };
      }

      return {
        _id: `overflow-${item._id || idx}`,
        slug: item.slug || item._id,
        label: item.name,
        image: item.image,
        icon: isSVGString(item.image)
          ? () => (
              <span
                className="h-4 w-4"
                dangerouslySetInnerHTML={{
                  __html: item.image?.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"').replace(/stroke="[^"]*"/g, 'stroke="currentColor"'),
                }}
              />
            )
          : null,
        standout: false,
        link: item.link,
      };
    }) || [];

  const actionDivider = overflowedHeaderMenus?.length
    ? [
        { _id: "divider-actions", type: "divider" },
        {
          _id: "label-actions",
          label: "ACTIONS",
          standout: false,
          type: "label",
        },
      ]
    : [];

  const staticItems = [
    {
      _id: "change-password",
      icon: KeyIcon,
      label: "Change password",
      standout: false,
      onclick: () => setIsOpenModal(true),
    },
    {
      _id: "switch-admin",
      icon: WrenchScrewdriverIcon,
      label: "Switch to Admin",
      disabled: switchAdminButtonDisabled,
      standout: false,
      hidden: !["admin", "editor"].includes(user?.type),
      onclick: onHandleSwitchToAdmin,
    },
    // {
    //   _id: "travel",
    //   icon: BriefcaseIcon,
    //   label: "Travel",
    //   standout: false,
    //   hidden: !site?.travel_enabled,
    //   onclick: navigateToTravel,
    // },
    {
      _id: "manage-payments",
      icon: BanknotesIcon,
      label: "Manage Payments",
      standout: false,
      hidden: !(workspaceDetails?.billing_elegible_user_id === user?._id),
      onclick: navigateToPaymemnts,
    },
    {
      _id: "settings",
      icon: Cog6ToothIcon,
      label: "Settings",
      standout: false,
      hidden: !workspaceDetails?.workato_elegible_user_ids?.includes(user?._id) || workspaceDetails?.workato_enabled === false,
      onclick: navigateToSettings,
    },
    {
      _id: "logout",
      icon: ArrowRightStartOnRectangleIcon,
      label: "Logout",
      onclick: logout,
      standout: false,
    },
  ];

  return [...userBlock, ...divider, ...overflowItems, ...actionDivider, ...staticItems];
};

export const isPasswordInvalid = (password, policy) => {
  if (!password) return true;

  const { min_length = 8, require_uppercase, require_lowercase, require_number, require_special } = policy || {};

  const requirements = [password.length < min_length, require_uppercase && !/[A-Z]/.test(password), require_lowercase && !/[a-z]/.test(password), require_number && !/[0-9]/.test(password), require_special && !/[\W_]/.test(password), /\s/.test(password)];

  return requirements.some((requirement) => requirement === true);
};
